module.exports = __webpack_public_path__ + "static/media/norte_medio.0fcb4b2e.jpg";